import { Grid2 as Grid } from '@mui/material'
import ProfileCard from './ProfileCard'
import BasicDetailsCard from './BasicDetailsCard'
import PremiumCard from './PremiumCard'
import ClaimsCard from './ClaimsCard'

const BasicDetails = () => {
  return (
    <Grid container direction={'row'} spacing={1.5}>
      <Grid size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}>
        <ProfileCard actions={true} />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, lg: 9, md: 9, xl: 9 }}>
        <BasicDetailsCard />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, lg: 3, md: 3, xl: 3 }}>
        <PremiumCard premiumPiad={12000} sumInsured={500000} />
      </Grid>
      <Grid size={{ xs: 12, sm: 12, lg: 9, md: 9, xl: 9 }}>
        <ClaimsCard />
      </Grid>
    </Grid>
  )
}

export default BasicDetails
